const initialState = {
  username: '',
  uuid: '',
  tokenType: 'Bearer',
  isLoggedIn: false,
  token: '',
  role: '',
  name: '',
  assets: [],
  project: null,
  showSidebar: true,
  pages: [],
  events: [],
  collections: [],
  snippets: [],
  iPlugins: [],
  loadProjectDetailPending: false,
  loadProjectDetailError: null,
  loadEditorCollectionsPending: true,
  loadEditorCollectionsError: null,
  loadPagesPending: false,
  loadPagesError: null,
  loadProjectPending: false,
  loadProjectError: null,
  loadProjectAssetsPending: false,
  loadProjectAssetsError: null,
  loadSnippetsPending: false,
  loadSnippetsError: null,
  loadEventsPending: false,
  loadEventsError: null,
  loadConditionsPending: false,
  loadConditionsError: null,
  loadInstalledPluginPending: false,
  loadInstalledPluginError: null,
  updateLatestPublishVersionPending: false,
  updateLatestPublishVersionError: null,
  addLastAccessPending: false,
  addLastAccessError: null,
};

export default initialState;
